module.exports = __webpack_public_path__ + "img/left.7dc9bc19.png";